import { Heading, List, Stack, Text } from '@chakra-ui/react';

export const TCEN = () => {
  return (
    <div>
      <Heading as="h1" size="md" mt={4}>
        GENERAL TERMS AND CONDITIONS
      </Heading>
      <Text fontWeight="bold" mt={2}>
        SUP SUP CLUB B.V.
      </Text>
      <Text fontStyle="italic">(Version February 2026)</Text>
      <Stack gap={4} mt={4}>
        <Heading size="md">Article 1 – Definitions</Heading>
        <Text fontWeight="bold">Sup Sup Club</Text>
        <Text>
          Sup Sup Club B.V., a private limited liability company incorporated
          under the laws of the Netherlands, having its registered office in
          Amsterdam and its business address at Herengracht 406, 1017 BX
          Amsterdam, registered with the Dutch Chamber of Commerce under number
          81205309.
        </Text>
        <Text fontWeight="bold">Website</Text>
        <Text>
          www.supsupclub.com or any other website designated by Sup Sup Club.
        </Text>
        <Text fontWeight="bold">Web Application</Text>
        <Text>
          The digital environment accessible via app2.supsupclub.com or any
          other URL designated by Sup Sup Club, through which reservations are
          made and lockers are opened.
        </Text>
        <Text fontWeight="bold">Customer Service</Text>
        <Text>
          Reachable via telephone number +31 85 130 9686, via e-mail
          info@supsupclub.com, or via the contact options listed in the Web
          Application.
        </Text>
        <Text fontWeight="bold">Station</Text>
        <Text>
          An automated, unmanned rental station in which SUP boards, accessories
          and lockers are located.
        </Text>
        <Text fontWeight="bold">Locker</Text>
        <Text>
          The lockable compartments within the Station that are accessible via
          the Web Application.
        </Text>
        <Text fontWeight="bold">Self-Service Rental</Text>
        <Text>
          The automated rental of SUP boards without physical presence,
          supervision, instruction or guidance by staff.
        </Text>
        <Text fontWeight="bold">Participant</Text>
        <Text>
          Any natural person who uses a SUP board or Locker reserved via Sup Sup
          Club.
        </Text>
        <Text fontWeight="bold">Booking Participant</Text>
        <Text>
          The natural person who reserves one or multiple SUP boards via the Web
          Application.
        </Text>
        <Text fontWeight="bold">Agreement</Text>
        <Text>
          The agreement between Sup Sup Club and the Participant for the
          temporary use of a SUP board, Locker and Station.
        </Text>

        <Heading size="md">
          Article 2 – Contracting Party &amp; Self-Service Model
        </Heading>
        <List.Root>
          <List.Item>
            The Agreement is concluded exclusively between the Participant and
            Sup Sup Club B.V.
          </List.Item>
          <List.Item>
            Any franchise holders, location providers or other involved parties
            are not contracting parties to the Agreement.
          </List.Item>
          <List.Item>
            Sup Sup Club is the provider of automated self-service watersport
            rental.
          </List.Item>
          <List.Item>
            In principle, no employee of Sup Sup Club, franchise holder or
            location provider is physically present at the Station.
          </List.Item>
          <List.Item>
            There is no supervision, no instruction and no rescue service
            present.
          </List.Item>
          <List.Item>
            The Participant expressly acknowledges that use of the rented
            equipment takes place independently and without guidance.
          </List.Item>
        </List.Root>

        <Heading size="md">
          Article 3 – Formation of the Agreement &amp; Group Bookings
        </Heading>
        <Text>The Agreement is concluded when:</Text>
        <List.Root>
          <List.Item>a reservation is made via the Web Application;</List.Item>
          <List.Item>these General Terms and Conditions are accepted;</List.Item>
          <List.Item>and payment has been completed.</List.Item>
        </List.Root>
        <Text>
          The Agreement automatically ends upon expiration of the reserved
          rental period.
        </Text>
        <Text>
          If the Booking Participant reserves multiple SUP boards:
        </Text>
        <List.Root>
          <List.Item>
            he/she declares to be authorized to conclude the Agreement on behalf
            of all co-users;
          </List.Item>
          <List.Item>
            he/she declares that all co-users have taken note of and agree to
            these General Terms and Conditions;
          </List.Item>
          <List.Item>
            he/she guarantees that all co-users comply with the participation
            requirements.
          </List.Item>
        </List.Root>
        <Text>
          The Booking Participant is jointly and severally liable for damage
          caused by the co-users registered by him/her.
        </Text>
        <Text>
          Each co-user shall individually be regarded as a Participant under
          these General Terms and Conditions.
        </Text>

        <Heading size="md">Article 4 – Participation Requirements</Heading>
        <Text>
          The minimum age for independent rental is 18 years.
        </Text>
        <Text>The Participant declares:</Text>
        <List.Root>
          <List.Item>
            to hold at least the Dutch swimming certificate A, or to possess an
            equivalent level of basic swimming proficiency sufficient to swim
            independently in open water and bring himself/herself to safety;
          </List.Item>
          <List.Item>to be physically capable of stand-up paddling;</List.Item>
          <List.Item>
            not to be under the influence of alcohol, drugs or similar
            substances.
          </List.Item>
        </List.Root>
        <Text>
          Minors may only use equipment under direct supervision of an adult
          (18+) who also holds at least the Dutch swimming certificate A or
          possesses an equivalent level of basic swimming proficiency.
        </Text>
        <Text>
          Sup Sup Club does not provide life jackets during self-service rental.
        </Text>
        <Text>
          The Participant acknowledges that the absence of life jackets is part
          of the self-service nature of the rental and that he/she bears full
          responsibility in this respect.
        </Text>
        <Text>
          Sup Sup Club reserves the right to refuse participation without
          stating reasons.
        </Text>

        <Heading size="md">Article 5 – Assumption of Risk</Heading>
        <Text>
          The Participant acknowledges that watersports, including stand-up
          paddling, involve inherent risks, including but not limited to:
        </Text>
        <List.Root>
          <List.Item>drowning;</List.Item>
          <List.Item>hypothermia;</List.Item>
          <List.Item>currents;</List.Item>
          <List.Item>collisions;</List.Item>
          <List.Item>sudden weather changes;</List.Item>
          <List.Item>physical injury.</List.Item>
        </List.Root>
        <Text>The Participant explicitly acknowledges that:</Text>
        <List.Root>
          <List.Item>no physical supervision is present;</List.Item>
          <List.Item>no rescue services are available;</List.Item>
          <List.Item>no life jackets are provided;</List.Item>
          <List.Item>
            he/she is solely responsible for assessing weather conditions, water
            conditions and personal safety.
          </List.Item>
        </List.Root>
        <Text>
          Use of the equipment is entirely at the Participant&apos;s own risk.
        </Text>

        <Heading size="md">
          Article 6 – Equipment, Locker &amp; Careful Use
        </Heading>
        <List.Root>
          <List.Item>
            The Participant must inspect the SUP board, accessories, Locker and
            Station for visible defects before use.
          </List.Item>
          <List.Item>
            The Participant must use the SUP board, Locker and Station carefully
            and in accordance with the instructions provided in the Web
            Application and at the Station.
          </List.Item>
          <List.Item>
            Opening and closing the Locker takes place entirely at the
            Participant&apos;s own risk.
          </List.Item>
          <List.Item>
            Use of the Locker takes place entirely at the Participant&apos;s own
            risk.
          </List.Item>
          <List.Item>
            Sup Sup Club does not accept any duty of safekeeping (bailment)
            regarding personal belongings placed in the Locker.
          </List.Item>
          <List.Item>
            Sup Sup Club is not liable for loss, theft or damage to belongings
            left in or near the Locker.
          </List.Item>
          <List.Item>
            The Participant is expressly advised not to leave valuable items in
            the Locker.
          </List.Item>
        </List.Root>
        <Text>In case of doubt or defect:</Text>
        <List.Root>
          <List.Item>the equipment or Locker must not be used;</List.Item>
          <List.Item>
            Sup Sup Club must be contacted immediately via the Web Application
            or Customer Service.
          </List.Item>
        </List.Root>
        <Text>
          Sup Sup Club is authorized to immediately deactivate a Locker or
          Station if safety requires.
        </Text>

        <Heading size="md">
          Article 7 – Prices, Modification &amp; Cancellation
        </Heading>
        <Text>Payment must be made in advance via the digital system.</Text>
        <Text>
          The Participant may modify the reservation up to four (4) hours before
          the start of the reserved period to another available time slot,
          exclusively via the Web Application and subject to availability.
        </Text>
        <Text>
          Modification of a reservation does not entitle the Participant to a
          refund.
        </Text>
        <Text>
          Cancellation by the Participant does not entitle the Participant to a
          refund.
        </Text>
        <Text>
          Sup Sup Club may cancel or suspend a reservation in case of:
        </Text>
        <List.Root>
          <List.Item>extreme weather conditions;</List.Item>
          <List.Item>safety risks;</List.Item>
          <List.Item>governmental restrictions;</List.Item>
          <List.Item>technical failures.</List.Item>
        </List.Root>
        <Text>
          In such case, Sup Sup Club shall first offer the Participant the
          possibility to reschedule the reservation free of charge.
        </Text>
        <Text>
          If rescheduling is not possible or not accepted by the Participant,
          the paid amount shall be refunded.
        </Text>
        <Text>
          Pursuant to article 6:230p sub e of the Dutch Civil Code, the
          statutory right of withdrawal does not apply, as the Agreement
          concerns a leisure activity with a specific date or period of
          performance.
        </Text>

        <Heading size="md">Article 8 – Liability</Heading>
        <Text>
          Sup Sup Club shall only be liable in case of wilful misconduct or
          gross negligence of its statutory directors.
        </Text>
        <Text>
          Any liability is limited to the amount paid out under the applicable
          insurance policy.
        </Text>
        <Text>Sup Sup Club is not liable for:</Text>
        <List.Root>
          <List.Item>drowning;</List.Item>
          <List.Item>personal injury;</List.Item>
          <List.Item>consequential damages;</List.Item>
          <List.Item>loss or theft of personal belongings;</List.Item>
          <List.Item>damages resulting from weather conditions;</List.Item>
          <List.Item>
            injury arising from the use of the Station or Locker, unless caused
            by wilful misconduct or gross negligence.
          </List.Item>
        </List.Root>
        <Text>
          Use of the SUP board, Locker and Station takes place entirely at the
          Participant&apos;s own risk.
        </Text>
        <Text>
          These limitations of liability also apply for the benefit of franchise
          holders, location providers, employees and auxiliaries engaged by Sup
          Sup Club.
        </Text>
        <Text>
          The Participant indemnifies Sup Sup Club against claims from third
          parties arising from his/her use of the SUP board, Locker or Station.
        </Text>

        <Heading size="md">Article 9 – Damage</Heading>
        <Text>The Participant is liable for damage to:</Text>
        <List.Root>
          <List.Item>the SUP board;</List.Item>
          <List.Item>accessories;</List.Item>
          <List.Item>the Locker;</List.Item>
          <List.Item>the Station;</List.Item>
        </List.Root>
        <Text>
          if such damage results from negligence, improper use or intentional
          conduct.
        </Text>

        <Heading size="md">Article 10 – Force Majeure</Heading>
        <Text>
          Sup Sup Club shall not be liable for any failure resulting from force
          majeure, including but not limited to extreme weather conditions,
          natural disasters, governmental measures or technical system failures.
        </Text>

        <Heading size="md">Article 11 – Personal Data</Heading>
        <Text>
          Personal data is processed in accordance with the General Data
          Protection Regulation (GDPR) and Sup Sup Club&apos;s Privacy Policy.
        </Text>

        <Heading size="md">Article 12 – Governing Law</Heading>
        <List.Root>
          <List.Item>
            All legal relationships with Sup Sup Club are governed exclusively
            by Dutch law.
          </List.Item>
          <List.Item>
            Any disputes shall be submitted exclusively to the competent court
            in Amsterdam.
          </List.Item>
          <List.Item>
            In case of inconsistency between the Dutch and English version of
            these General Terms and Conditions, the Dutch version shall prevail.
          </List.Item>
        </List.Root>
      </Stack>
    </div>
  );
};
